import {
  DEFAULT_QUIZ_STORAGE_NAMESPACE,
  MINI_QUIZ_STORAGE_NAMESPACE,
  type QuizStorageNamespace,
} from '../defs/localStorage';

interface Params {
  isMobile: boolean;
  /** The unexpired `funnel.started` value, when this browser has one. */
  startedFunnel?: QuizStorageNamespace;
  /** The account's raw Exp 255 assignment, excluding Exp 260/266 inference. */
  isExp255Treatment: boolean;
}

/**
 * Resolves the funnel family for an Exp 260/266 guest.
 *
 * The mini quiz is mobile-only. On mobile, an active funnel wins; without
 * active local progress, an Exp 255 overlap implies the mini quiz and every
 * other re-engagement guest starts the full quiz.
 */
export function resolveReengagementFunnelNamespace({
  isMobile,
  startedFunnel,
  isExp255Treatment,
}: Params): QuizStorageNamespace {
  if (!isMobile) {
    return DEFAULT_QUIZ_STORAGE_NAMESPACE;
  }

  if (startedFunnel !== undefined) {
    return startedFunnel;
  }

  return isExp255Treatment
    ? MINI_QUIZ_STORAGE_NAMESPACE
    : DEFAULT_QUIZ_STORAGE_NAMESPACE;
}
